import axios from "axios";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { isDevMode } from "../utils/utilities";
import { useGlobalStore } from "../utils/global";
import Constants from "../utils/constants";

const timeout = /*minutes*/ 1 * /*secons*/ 60 * /*miliseconds*/ 1000;

export const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: timeout,
});

export const useAPIs = () => {
  const navigate = useNavigate();
  const { showNotification, showLoading, hideLoading } = useGlobalStore();

  useEffect(() => {
    /*REQUEST*/
    const resRequestInterceptor = (config) => {
      if (isDevMode()) {
        console.info("REQUEST CONFIG", config);
      }

      showLoading();

      const userLocalStorage = localStorage.getItem("user");
      const user = userLocalStorage ? JSON.parse(userLocalStorage) : null;

      if (user && user.token) {
        config.headers["Authorization"] = `Bearer ${user.token}`;
      }

      config.headers["Access-Control-Allow-Origin"] = "*";
      config.headers["Access-Control-Allow-Headers"] = "Origin, X-Requested-With, Content-Type, Accept";
      config.headers["Content-Type"] = "application/json";

      return config;
    };

    const errResponseInterceptor = (error) => {
      if (isDevMode()) {
        console.info("REQUEST ERROR", error);
      }

      hideLoading();
      return Promise.reject(error);
    };

    /*RESPONSE*/
    const resInterceptor = (response) => {
      let result: any;

      if (isDevMode()) {
        console.info("RESPONSE RESULT", response);
      }

      if (!response) {

      } else if (response.data.successed || response.data.fieldErrors) {
        result = { ...response };
      } else {
        response.data.message.forEach((message) => {
          showNotification({
            title: "Error",
            message: message.message,
            isError: true,
          });
          if (window.location.href.toLocaleLowerCase().includes(Constants.APPURLS.BENEFITS))
            navigate("/");
        });
      }

      hideLoading();

      return result;
    };

    const errInterceptor = (error) => {
      if (isDevMode()) {
        console.error("RESPONSE ERROR", error);
      }
      hideLoading();

      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        if (typeof error.response.data.message === "string") {
          showNotification({
            title: "Error",
            message: error.response.data.message,
            isError: true,
          });
        } else {
          error.response.data.message.forEach((message) => {
            let valid_message = message.message;
            if(valid_message.includes("CreateToken")){
              valid_message = "Usuario o contraseña inválido";
            }
            showNotification({
              title: "Error",
              message: valid_message,
              isError: true,
            });
          });
        }
      } else if (error.data && error.data.Message) {
        showNotification({
          title: "Error",
          message: error.data.Message,
          isError: true,
        });
      } else if (error.message) {
        showNotification({
          title: "Error",
          message: error.message,
          isError: true,
        });
      }

      if (error.response && error.response.status === 401) {
        navigate(window.location.href.toLocaleLowerCase().includes(Constants.BPMS_TASKS) ? "/" : "/login");
      }

      return Promise.reject(error);
    };

    const OFVAPIREQUEST = API.interceptors.request.use(
      resRequestInterceptor,
      errResponseInterceptor
    );

    const OFVAPIRESPONSE = API.interceptors.response.use(
      resInterceptor,
      errInterceptor
    );

    return () => {
      API.interceptors.request.eject(OFVAPIREQUEST);
      API.interceptors.response.eject(OFVAPIRESPONSE);
    };
  }, []);
};
